import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const PopularAirlinesContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 200px; */
  width: 100%;
  background-color: #ffffff;
  margin-bottom: 60px;
  ${down('md')} {
    background-color: #f8faf9;
    margin-bottom: 5px;
    margin-bottom: 30px;
  }
`
export const PopularAirlinesHeading = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000000;
  margin: 0px 0px 25px 0px;
  ${down('md')} {
    margin: 10px 0px 24px 0px;
  }
`
export const PopularAirlinesCards = styled.div`
  display: flex;
  gap: 16px;

  ${down('md')} {
    gap: 0px;
    div {
      margin-right: 16px;
      margin-left: 0px;
    }
  }
`
export const PopularAirlinesCard = styled.div<{ isTablet?: boolean }>`
  position: relative;
  width: 125px;
  height: 60px;
  border-radius: 4px;
  padding: 0;
  background: transparent;
  border-radius: 4px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`
export const SeeAllAirlines = styled.a`
  display: flex;
  padding: 7px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid#D7DDDB;
  background: #fff;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  height: 32px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: 0.3s all;
  &:hover {
    background-color: rgb(248, 250, 249);
    border-color: rgb(189, 197, 193);
  }
  ${down('md')} {
    font-size: 16px;
    margin-top: 16px;
    height: 50px;
  }
`
